import { toast as sonnerToast } from 'sonner';

export type ToastLevel = 'info' | 'success' | 'warning' | 'error';

export type ToastAction = {
  label: string;
  onClick?: () => void;
};

export type ToastOptions = {
  description?: string;
  duration?: number;
  action?: ToastAction;
};

const base = (message: string, options?: ToastOptions) => {
  return sonnerToast(message, options as any);
};

const info = (message: string, options?: ToastOptions) => {
  return sonnerToast(message, options as any);
};

const success = (message: string, options?: ToastOptions) => {
  return sonnerToast.success(message, options as any);
};

const warning = (message: string, options?: ToastOptions) => {
  return sonnerToast.warning(message, options as any);
};

const error = (message: string, options?: ToastOptions) => {
  return sonnerToast.error(message, options as any);
};

const action = (message: string, action: ToastAction, options?: Omit<ToastOptions, 'action'>) => {
  return sonnerToast(message, { ...options, action } as any);
};

type AckOptions = Omit<ToastOptions, 'action' | 'duration'> & {
  onAcknowledge?: () => void;
};

export const ack = (message: string, options?: AckOptions): Promise<void> => {
  return new Promise((resolve) => {
    const id = sonnerToast(message, {
      duration: Infinity,
      action: {
        label: 'OK',
        onClick: () => {
          sonnerToast.dismiss(id);
          if (options?.onAcknowledge) options.onAcknowledge();
          resolve();
        },
      },
      ...(options as any),
    } as any);
  });
};

const promise = async <T>(
  p: Promise<T>,
  messages: {
    loading: string;
    success: string | ((value: T) => string);
    error: string | ((err: unknown) => string);
  }
) => {
  return sonnerToast.promise(p, messages as any);
};

const dismiss = (id?: string | number) => sonnerToast.dismiss(id as any);

export const toast = Object.assign(base, {
  info,
  success,
  warning,
  error,
  action,
  ack,
  promise,
  dismiss,
});
